import "./HeroSection.css";

const HeroSection = () => {
  return (
    <div className="hero-section-kf">

      {/* Lock icon */}
      <img
        src="/assets/img/group_393.png"
        alt="lock"
        className="gold-loan-banner"
      />

    </div>
  );
};

export default HeroSection;